import useGetApi from 'src/api/useGetApi';

import {
  AUTH_QUERY_RETRY_DELAY_MS,
  shouldRetryAuthQuery,
} from 'src/api/auth/authQueryConfig';

interface WorkOSConnection {
  connectionType: string;
  authorizationUrl: string;
}

interface WorkOSResponse {
  connections: WorkOSConnection[];
  fallbackAuthorizationUrl: string | null;
}

export const useWorkOSUrl = () => {
  return useGetApi<WorkOSResponse>({
    endpoint: 'auth/workos',
    options: {
      retry: shouldRetryAuthQuery,
      retryDelay: AUTH_QUERY_RETRY_DELAY_MS,
    },
  });
};
